// import { ADD_EVENT_LISTENER_TAG } from '../../common/wrap/wrap-websocket'
import { FEATURE_NAMES } from '../../loaders/features/features';
export var FEATURE_NAME = FEATURE_NAMES.metrics;
export var SUPPORTABILITY_METRIC = 'sm';
export var CUSTOM_METRIC = 'cm';
export var SUPPORTABILITY_METRIC_CHANNEL = 'storeSupportabilityMetrics';
export var CUSTOM_METRIC_CHANNEL = 'storeEventMetrics'; // export const WATCHABLE_WEB_SOCKET_EVENTS = ['new', 'send', 'close', ADD_EVENT_LISTENER_TAG]